import { CustomSelectOption } from 'components/shared/CustomSelect';
import EXPERIENCEBYROLEBYFRAMEWORK from 'data/mantechcar25/experience-by-tech-framework.json';
import EXPERIENCEBYROLEBYLANGUAGE from 'data/mantechcar25/experience-by-tech-language.json';
import EXPERIENCEBYROLEBYOTHER from 'data/mantechcar25/experience-by-tech-other.json';
import { TFunction } from 'hooks/useI18n';
import { SwitcherProps } from '../shared/switcher/Switcher.types';
import LeastWantedTechsByFrameworks from './charts/LeastWantedTechsByFrameworks';
import LeastWantedTechsByLanguage from './charts/LeastWantedTechsByLanguage';
import LeastWantedTechsByOther from './charts/LeastWantedTechsByOther';
import MostUsedTechsByFrameworks from './charts/MostUsedTechsByFrameworks';
import MostUsedTechsByLanguage from './charts/MostUsedTechsByLanguage';
import MostUsedTechsByOther from './charts/MostUsedTechsByOther';
import ExperienceByRole from './ExperienceByRole';

export const TALENTBYTECHOPTIONS = (t: TFunction): CustomSelectOption[] => [
  {
    label: t('mantechcar25.talent.talent-per-tech.back'),
    value: 'back'
  },
  {
    label: t('mantechcar25.talent.talent-per-tech.front'),
    value: 'front'
  },
  {
    label: t('mantechcar25.talent.talent-per-tech.mobile'),
    value: 'mobile'
  },
  {
    label: t('mantechcar25.talent.talent-per-tech.data'),
    value: 'data'
  },
  {
    label: t('mantechcar25.talent.talent-per-tech.infra'),
    value: 'infra'
  }
];

export const MOSTUSEDTECHSTABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'mostUsedTechs',
  tabs: [
    {
      id: 'mostUsedTechsByLang',
      label: t('mantechcar25.talent.most-used-techs.languages'),
      content: <MostUsedTechsByLanguage />
    },
    {
      id: 'mostUsedTechsByFrameworks',
      label: t('mantechcar25.talent.most-used-techs.frameworks'),
      content: <MostUsedTechsByFrameworks />
    },
    {
      id: 'mostUsedTechsByOther',
      label: t('mantechcar25.talent.most-used-techs.other-techs'),
      content: <MostUsedTechsByOther />
    }
  ]
});

export const LEASTWANTEDTECHSTABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'leastWantedTechs',
  tabs: [
    {
      id: 'leastWantedTechsByLang',
      label: t('mantechcar25.talent.least-wanted-techs.languages'),
      content: <LeastWantedTechsByLanguage />
    },
    {
      id: 'leastWantedTechsByFrameworks',
      label: t('mantechcar25.talent.least-wanted-techs.frameworks'),
      content: <LeastWantedTechsByFrameworks />
    },
    {
      id: 'leastWantedTechsByOther',
      label: t('mantechcar25.talent.least-wanted-techs.other-techs'),
      content: <LeastWantedTechsByOther />
    }
  ]
});

export const EXPERIENCEBYROLETABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'experienceByRole',
  tabs: [
    {
      id: 'experienceByRoleByLang',
      label: t('mantechcar25.talent.main-techs.languages'),
      content: <ExperienceByRole data={EXPERIENCEBYROLEBYLANGUAGE} />
    },
    {
      id: 'experienceByRoleByFramework',
      label: t('mantechcar25.talent.main-techs.frameworks'),
      content: <ExperienceByRole data={EXPERIENCEBYROLEBYFRAMEWORK} />
    },
    {
      id: 'experienceByRoleByOther',
      label: t('mantechcar25.talent.main-techs.other-techs'),
      content: <ExperienceByRole data={EXPERIENCEBYROLEBYOTHER} />
    }
  ]
});
